import "./header.less";

import { StateService } from "@uirouter/angularjs";
import { IComponentOptions } from "angular";
import { isUndefined } from "lodash";
import { UserManager } from "oidc-client";

import { DASHBOARD_STATE } from "../../dashboard/dashboard.router";
import { SIDENAV_ID } from "../sidenav/sidenav.component";
import { HeaderService } from "./../../core/header.service";

class HeaderComponentController {
    private logoImageSrc: string;
    private user: Oidc.User;

    // labels
    get username(): string {
        if (!this.user){
            return '';
        }

        return this.user.profile[this.USERNAME_CLAIM_TYPE];
    }


    // disabled
    get showLogout(): boolean { return !isUndefined(this.user) && this.user !== null; }

    static $inject = ["$mdSidenav", "headerService", "BoardWebAdminUserManager", "$state", "USERNAME_CLAIM_TYPE"];
    constructor(private $mdSidenav: ng.material.ISidenavService, private headerService: HeaderService, private userManager: UserManager, private $state: StateService, private readonly USERNAME_CLAIM_TYPE: string
    ) {
        userManager.getUser().then(user => {
            this.user = user;
        });

        this.logoImageSrc = require("./../../../Content/boardLogo.svg");
    }

    private toggleSidenav() {
        this.$mdSidenav(SIDENAV_ID).toggle();
    }

    private get title() {
        return this.headerService ? this.headerService.headerTitle : null;
    }

    private logout() {
        this.userManager.signoutRedirect();
    }

    private goDashboard() {
        this.$state.go(DASHBOARD_STATE);
    }
}

const headerComponent: IComponentOptions = {
    controller: HeaderComponentController,
    template: require("./header.html"),
    bindings: {
        existingConfigurations: "<"
    }
};

export { headerComponent };



// WEBPACK FOOTER //
// ./app/layout/header/header.component.ts